import { layout } from 'Constants';
import styled from 'styled-components';

export default styled.div`

font-family: "Elevance Sans Regular";
font-weight: normal;
font-size: 16px;
line-height: 22px;
max-width:1135px ;
align-self:center ;
 
color: #131331;
 
 
@media screen and (max-width: ${layout.breakpoints.mobile}) {
    padding: 10px;
  }



font-size: 0.8em;
 
${props => props.center && 'text-align: center'}
`
